export default {
  "NoticeAgreementsSettingSummary.Title": "キャンペーン・特典などのお知らせ",
  "NoticeAgreementsSettingSummary.MobileTitle":
    "キャンペーン・特典などの{linebreak}お知らせ",
}
